import React from 'react';
import {
  FormLabel,
  InputGroup,
  InputLeftElement,
  Icon,
} from '@podiumhq/design-system';

import { FormElementFieldError } from './FormElementFieldError';
import { FormElementFieldRightIcon } from './FormElementFieldRightIcon';
import { FormElementsInputWrapper } from './styles';

export const FormFieldWrapper = ({
  children,
  displayErrorIcon = true,
  error,
  iconProps,
  id,
  inputGroupSize = 'md',
  label,
  size,
  ...wrapperProps
}) => {
  const hasError = displayErrorIcon && error;
  const rightIconProps = hasError ? {} : iconProps;
  const shouldDisplayRightIcon =
    (iconProps?.icon && !iconProps?.side) || hasError;
  const shouldDisplayLeftIcon = iconProps?.icon && iconProps?.side;

  return (
    <FormElementsInputWrapper
      error={error}
      id={`${id}-form-wrapper`}
      size={size}
      {...wrapperProps}
    >
      {label && <FormLabel htmlFor={id}>{label}</FormLabel>}

      <InputGroup size={inputGroupSize}>
        {shouldDisplayLeftIcon && (
          <InputLeftElement mt={size === 'lg' ? '5px' : '0'} size={size}>
            <Icon
              sx={{ svg: { fill: iconProps?.fillColor } }}
              type={iconProps?.icon}
              size={iconProps?.size}
            />
          </InputLeftElement>
        )}

        {children}

        {shouldDisplayRightIcon && (
          <FormElementFieldRightIcon
            fillColor={hasError ? 'red.base' : iconProps?.fillColor}
            outline="none"
            size={size}
            tabIndex={hasError ? null : -1}
            type={hasError ? 'AlertCircle' : iconProps?.icon}
            {...rightIconProps}
          />
        )}
      </InputGroup>

      {error && (
        <FormElementFieldError displayError={!!error} mt="8px">
          {error}
        </FormElementFieldError>
      )}
    </FormElementsInputWrapper>
  );
};
